export default "__VITE_ASSET__Bju3o6AG__"